/* PUNIVERSE build — the ritual finder.
   Three questions, one recommendation. The routing is a straight port of resolve() from
   site/src/components/RitualPage.tsx: care is the anchor, when/feel choose between the two face
   oils and colour the words. Product names, prices and links come from the store (the JSON block
   the section prints), never from here. */
(function () {
  var root = document.querySelector('[data-ge-finder]');
  var result = document.querySelector('[data-ge-result]');
  var json = document.querySelector('[data-ge-finder-products]');
  if (!root || !result || !json) return;

  var P = JSON.parse(json.textContent);
  var answers = { when: null, feel: null, care: null };

  function resolve(when, feel, care) {
    if (care === 'hair') {
      return {
        key: 'hair',
        feeling:
          feel === 'restored'
            ? 'You want to feel like yourself again — the way your hair was before this season of life took its toll.'
            : "You want your hair to feel cared for, properly, the way it hasn't in a while.",
        ritual:
          'Hair Essence is the oil Samina first made for herself — rosemary-led, twenty-nine botanicals, worked slowly into the scalp and left to do its quiet work overnight.',
        then: { key: 'trio', line: 'Hair answers in months, not days. A three-bottle course sees you through.' },
      };
    }
    if (care === 'beard') {
      return {
        key: 'kings',
        feeling:
          when === 'morning'
            ? 'You want one bottle that does the job of three — beard softened, skin settled, before the day starts.'
            : "You want the day's dryness and itch eased out, and the skin under the beard looked after too.",
        ritual:
          'Kings Beard Oil is one oil for beard, hair and the skin beneath — jojoba, argan, sweet almond and castor, warmed in the palms and worked through after washing. It leaves a warm trace of sandalwood, vanilla and sweet orange.',
      };
    }
    if (care === 'body') {
      return {
        key: 'body',
        feeling:
          when === 'exercise'
            ? "You want to come back to yourself after the day's effort — to ease it out, not carry it home."
            : 'You want skin that feels soft the same evening, not tight and forgotten.',
        ritual:
          'Golden Body Essence Luxury Oil is the one people feel first — jojoba, argan, almond and coconut, warmed between the hands and smoothed over skin still damp from the bath.',
        then: { key: 'set', line: "When you're ready for the whole ritual — face, hair and body — it lives in one box." },
      };
    }
    var morningish = when === 'morning' || feel === 'awake';
    var eveningish = when === 'evening' || when === 'sleep' || feel === 'calm' || feel === 'restored';
    if (morningish && !eveningish) {
      return {
        key: 'phoenix',
        feeling: 'You want to begin the day awake — light on the skin, glowing, ready.',
        ritual:
          'Phoenix Radiance Day Oil is a lightweight morning oil — black seed, jojoba, argan and rosehip — pressed into the skin before anything else, worn all day.',
        then: { key: 'duo', line: 'Pair it with Laila Aura by night, and your face is cared for around the clock.' },
      };
    }
    if (eveningish && !morningish) {
      return {
        key: 'laila',
        feeling: 'You want the day to soften — the lights low, the mind slowing, the skin repairing while you rest.',
        ritual:
          'Laila Aura Night Oil is an overnight facial oil — black seed, jojoba, rosehip and frankincense — the last, unhurried gesture before sleep.',
        then: { key: 'duo', line: 'Add Phoenix Radiance for the morning, and the two hold your skin between them.' },
      };
    }
    return {
      key: 'duo',
      feeling: 'You want your skin held morning and night — bright by day, repairing by dark.',
      ritual:
        'The Glow Duo is the two-step ritual: Phoenix Radiance to wake the skin, Laila Aura to let it recover. One gesture each end of the day.',
    };
  }

  function card(key) {
    var p = P[key];
    if (!p) return '';
    return (
      '<a class="ritualp__card is-featured" href="' + p.href + '">' +
      '<img src="' + p.img + '" alt="' + p.name + '" loading="lazy">' +
      '<span class="ritualp__cardBody">' +
      '<span class="ritualp__cardKind">' + p.kind + '</span>' +
      '<span class="ritualp__cardName">' + p.name + '</span>' +
      '<span class="ritualp__cardPrice">' + p.price + '</span>' +
      '<span class="ritualp__cardCta">Shop <span aria-hidden="true">&rarr;</span></span>' +
      '</span></a>'
    );
  }

  var q = function (sel) { return document.querySelector(sel); };

  function paint() {
    // each question unlocks the next, exactly as the preview did
    var order = ['when', 'feel', 'care'];
    order.forEach(function (name, i) {
      var group = root.querySelector('[data-q="' + name + '"]');
      var ready = i === 0 || answers[order[i - 1]];
      group.classList.toggle('is-waiting', !ready);
      group.querySelectorAll('.ritualp__choice').forEach(function (b) {
        b.disabled = !ready;
        var on = answers[name] === b.dataset.v;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', String(on));
      });
    });

    if (!(answers.when && answers.feel && answers.care)) {
      result.hidden = true;
      return;
    }

    var r = resolve(answers.when, answers.feel, answers.care);
    var p = P[r.key];
    q('[data-ge-result-title]').textContent = (p ? p.name : '') + '.';
    q('[data-ge-result-feeling]').textContent = r.feeling;
    q('[data-ge-result-ritual]').textContent = r.ritual;
    q('[data-ge-result-card]').innerHTML = card(r.key);

    var then = q('[data-ge-result-then]');
    if (r.then && P[r.then.key]) {
      var t = P[r.then.key];
      q('[data-ge-result-then-line]').textContent = r.then.line;
      var link = q('[data-ge-result-then-link]');
      link.href = t.href;
      link.innerHTML = t.name + ' · ' + t.price + '<span aria-hidden="true"> &rarr;</span>';
      then.hidden = false;
    } else {
      then.hidden = true;
    }

    result.hidden = false;
    result.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  root.addEventListener('click', function (e) {
    var btn = e.target.closest('.ritualp__choice');
    if (!btn || btn.disabled) return;
    answers[btn.closest('[data-q]').dataset.q] = btn.dataset.v;
    paint();
  });

  var reset = document.querySelector('[data-ge-reset]');
  if (reset) {
    reset.addEventListener('click', function () {
      answers = { when: null, feel: null, care: null };
      paint();
      root.scrollIntoView({ behavior: 'smooth' });
    });
  }

  paint();
})();
